export const LOGOUT_SUCCESS = 'logout-success'
export const LOGIN_SUCCESS = 'login-success'
